import React, { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'
import x from '../../assets/icons/close.svg'
import updateUse from '../../apis/updateUse'

const EditClient = ({ active, close, client, updateData }) => {
  console.log(client, 'cccccllienns')
  const popupref = useRef(null)
  const [loading, setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')

  const [userData, setUserData] = useState({
    email: client.email || '',
    first_name: client.first_name || '',
    address: client.address || '',
    last_name: client.last_name || '',
    mobile: client.mobile || '',
    type: client.type || '',
  })

  const handelUpdateUser = async (e) => {
    e.preventDefault()
    let data = {}

    if (userData.first_name !== client.first_name) {
      data = { ...data, first_name: userData.first_name }
    }
    if (userData.last_name !== client.last_name) {
      data = { ...data, last_name: userData.first_name }
    }
    if (userData.email !== client.email) {
      data = { ...data, email: userData.first_name }
    }
    if (userData.address !== client.address) {
      data = { ...data, address: userData.address }
    }
    if (userData.mobile !== client.mobile) {
      data = { ...data, mobile: userData.mobile }
    }
    if (userData.type !== client.type) {
      data = { ...data, type: userData.type }
    }
    try {
      setLoading(true)
      await updateUse(client.id, data)

      updateData(
        {
          ...client,
          first_name: userData.first_name,
          last_name: userData.last_name,
          email: userData.email,
          address: userData.address,
          mobile: userData.mobile,
          type: userData.type,
        },
        'delete'
      )
      close()
    } catch (error) {
      console.log(error)
      setErrorMsg('Failed to Edit user')
    } finally {
      setLoading(false)
    }
  }

  const handleInputChange = (e) => {
    setErrorMsg('')
    const { name, value } = e.target
    if (name === 'mobile' && !/^\d*$/.test(value)) {
      setErrorMsg('Phone number can only contain numbers')
      return // Prevent updating the state if the value is invalid
    }
    setUserData((prevData) => ({ ...prevData, [name]: value }))
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        close()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [popupref, close])

  useEffect(() => {
    if (active) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [active])

  return (
    <motion.div
      className="fixed inset-0 bg-overlay/30 w-screen z-40 h-screen grid place-items-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        ref={popupref}
        initial={{ opacity: 0, y: -100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.3 }}
        className="w-1/2 min-h-72 overflow-hidden bg-white rounded-lg flex flex-col justify-center items-center"
      >
        <form onSubmit={handelUpdateUser} className="w-full">
          <div className="w-full px-8 py-5 flex flex-col gap-8">
            <div className="flex  border-b-[1px] pb-4 justify-between border-b-darkBlue w-full">
              <div className=" text-darkBlue ">
                Edit Client {`${client.first_name} ${client.last_name}`}
              </div>
              <img src={x} onClick={close} className="cursor-pointer" alt="" />
            </div>
            <div className=" flex flex-col gap-2 ">
              <div className=" w-full flex gap-4">
                <div className=" flex flex-col w-1/2 gap-1">
                  <div className=" text-darkBlue">First Name :</div>
                  <div className=" w-full rounded-xl p-4 border-[1px] border-b-darkBlue">
                    <input
                      value={userData.first_name}
                      onChange={handleInputChange}
                      className=" w-full focus:outline-none"
                      placeholder="First Name"
                      name="first_name"
                      id="first_name"
                    />
                  </div>
                </div>
                <div className=" flex flex-col w-1/2 gap-1">
                  <div className=" text-darkBlue">Last Name :</div>
                  <div className=" w-full rounded-xl p-4 border-[1px] border-b-darkBlue">
                    <input
                      value={userData.last_name}
                      onChange={handleInputChange}
                      className=" w-full focus:outline-none"
                      placeholder="Last Name"
                      name="last_name"
                      id="last_name"
                    />
                  </div>
                </div>
              </div>

              <div className=" w-full flex gap-4">
                <div className=" flex flex-col w-1/2 gap-1">
                  <div className=" text-darkBlue">Email :</div>
                  <div className=" w-full rounded-xl p-4 border-[1px] border-b-darkBlue">
                    <input
                      value={userData.email}
                      onChange={handleInputChange}
                      className=" w-full focus:outline-none"
                      placeholder="Email"
                      name="email"
                      id="email"
                      type="email"
                    />
                  </div>
                </div>
                <div className=" flex flex-col w-1/2 gap-1">
                  <div className=" text-darkBlue">Address :</div>
                  <div className=" w-full rounded-xl p-4 border-[1px] border-b-darkBlue">
                    <input
                      value={userData.address}
                      onChange={handleInputChange}
                      className=" w-full focus:outline-none"
                      placeholder="Address"
                      name="address"
                      id="address"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div className=" w-full flex gap-4">
                <div className=" flex flex-col w-1/2 gap-1">
                  <div className=" text-darkBlue">Phone :</div>
                  <div className=" w-full rounded-xl p-4 border-[1px] border-b-darkBlue">
                    <input
                      value={userData.mobile}
                      onChange={handleInputChange}
                      className=" w-full focus:outline-none"
                      placeholder="Phone"
                      name="mobile"
                      id="mobile"
                      type="text"
                    />
                  </div>
                </div>
                <div className="flex flex-col w-1/2 gap-1">
                  <div className="text-darkBlue">Type:</div>
                  <div className="w-full rounded-xl p-4 border-[1px] border-b-darkBlue">
                    <select
                      className="w-full focus:outline-none"
                      value={userData.type} // Bind value to userData.type
                      name="type"
                      id="type"
                      onChange={handleInputChange} // Update userData.type on change
                    >
                      <option value="normal">Retailer</option>
                      <option value="pos">Wholesaler</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {errorMsg && (
              <div className=" w-full flex justify-center items-center  p-2">
                <div className=" bg-red/25 p-1 text-red rounded">
                  {errorMsg}
                </div>
              </div>
            )}
          </div>
          <button
            disabled={loading || errorMsg}
            className="disabled:bg-darkBlue/50 rounded bg-blueButton text-white text-center p-4 w-full"
          >
            Edit
          </button>
        </form>
      </motion.div>
    </motion.div>
  )
}

export default EditClient
